import * as React from 'react'

import { DetailImage } from '../../../components/Detail/DetailImage'
import { useProductDetailDataCtx } from '../contexts/ProductDetailStateProvider'

type TProps = NoChildren & {
  showPictogramPlaceholder?: PropsOf<typeof DetailImage>['showPictogramPlaceholder']
}
/**
 * DetailImage connected to product detail context data.
 */
export const ProductDetailImage: React.FC<TProps> = ({ showPictogramPlaceholder }) => {
  const { product, isLoading } = useProductDetailDataCtx()
  const pictogram = product.pictogram ?? null

  return (
    <DetailImage
      isLoading={isLoading}
      imageUrl={product.image}
      pictogram={pictogram}
      placeholderUrl={product.placeholderImage}
      showPictogramPlaceholder={showPictogramPlaceholder}
    />
  )
}
